import ApptDashboardPage from "./ApptDashboard/ApptDashboard";
import ApptEditPage from "./ApptEdit/ApptEdit";

export const ApptDashboard = ApptDashboardPage;
export const ApptEdit = ApptEditPage;
